import { render } from "./league-details-basketball-modal.vue?vue&type=template&id=08fa7c42"
import script from "./league-details-basketball-modal.vue?vue&type=script&lang=js"
export * from "./league-details-basketball-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__